import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import he from 'he';

import siteData from '../services/siteData';
import api, { urlParamCharacter } from '../services/api';
import CategoriesLayout from '../layouts/CategoriesLayout';
import Jumbotron from '../components/Jumbotron';

export default class ClientPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      location: '',
      isLoading: true,
    };
  }

  componentDidMount() {
    const { match, history } = this.props;

    api.get(`/clients${urlParamCharacter}slug=${match.params.slug}`)
      .then((response) => {
        const data = response.data[0];
        this.setState({
          title: data.title.rendered,
          location: data.acf.location ? data.acf.location : '',
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });
  }

  render() {
    const { title, location, isLoading } = this.state;

    return (
      <CategoriesLayout path="/clients">
        <Helmet>
          <title>{`${title ? `${he.decode(title)} - ` : ''}${siteData.title}`}</title>
        </Helmet>
        <Jumbotron
          variant="clients"
          title={title || 'Loading'}
          text={location}
          isLoading={isLoading}
        />
      </CategoriesLayout>
    );
  }
}

ClientPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

ClientPage.defaultProps = {
  match: { params: { slug: '' } },
};
